import React, { useState } from 'react';

import ContactFinanceEditDialog from '~/components/Finances/FinanceApprovalsTab/ContactFinanceVerificationApprovals/ContactFinanceEditDialog';
import { FinancesIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { PendingVerificationsListResponsePendingVerificationItem } from '~/server_shared/openapi/data-contracts';

interface ContactFinanceVerificationActionCellProps {
  row: PendingVerificationsListResponsePendingVerificationItem;
  onReload: () => void;
}

const ContactFinanceVerificationActionCell: React.FC<ContactFinanceVerificationActionCellProps> = ({
  row,
  onReload,
}) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const handleClose = () => {
    onReload();
    setIsEditDialogOpen(false);
  };

  return (
    <div className="flex items-center justify-end gap-4">
      <InlineIconButton
        icon={FinancesIcon}
        onClick={() => setIsEditDialogOpen(true)}
        tooltipTitle="Contact Finance Details"
      />
      {isEditDialogOpen && (
        <ContactFinanceEditDialog contactId={row.contact_id} onClose={handleClose} onSave={handleClose} />
      )}
    </div>
  );
};

export default ContactFinanceVerificationActionCell;
